export default function HiredIcon() {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 7.25L17.25 1.25H6.75L1.5 7.25M22.5 7.25L12 18.5M22.5 7.25H1.5M12 18.5L1.5 7.25M12 18.5L16.6023 7.25L12 1.25L7.39772 7.25L12 18.5Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
